import { array, boolean, number, object, string, StringSchema } from 'yup';
import { Flatten } from '@Utils/types/Flatten';
import { ValidateOptions, AnyObject } from 'yup/lib/types';

// Optional http(s) scheme, a dotted host, optional port, then any sane
// path/query/fragment. The old pattern allowed only \w and # inside path
// segments, so any slug with a hyphen — every classroom URL — was rejected;
// its /g flag also carried lastIndex between validations, making the same
// value pass and fail alternately.
const re = /^(https?:\/\/)?[\w-]+(\.[\w-]+)+(:\d+)?([/?#]\S*)?$/;

export const ADD_NEWSFEED = object({
	content: string().required(),
	redirection_url: string().matches(re, 'URL is not valid').required(),
	photo: string().required(),
	is_active: boolean(),
});

export const EDIT_NEWSFEED = object({
	id: number().required(),
}).concat(ADD_NEWSFEED);

export const FULL_SCHEMA = ADD_NEWSFEED.concat(EDIT_NEWSFEED);
export type AddNewsFeedForm = typeof ADD_NEWSFEED.__outputType;
export type EditNewsFeedForm = typeof EDIT_NEWSFEED.__outputType;

export type FlattenNewsFeedForm = Flatten<AddNewsFeedForm>;
